module.exports = __webpack_public_path__ + "static/media/shirt.e92ca21b.jpg";